"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilingCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const utils_1 = require("@navinc/utils");
const zebra_list_1 = __importStar(require("../zebra-list"));
const labeled_value_1 = require("../labeled-value");
const CardContent = styled_components_1.default.div.withConfig({ displayName: "reports-CardContent", componentId: "reports-yozoz1" }) `
  display: grid;
  grid-gap: 16px;
`;
const LabeledItemWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-LabeledItemWrapper", componentId: "reports-msewmx" }) `
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    grid-template-columns: 1fr 1fr;
  }
`;
/**
 * The FilingCard component displays prominently the filing number and date, and utilizes the ZebraList
 * component to stripe whatever is provided as details.
 */
const FilingCard = ({ testId, filing }) => {
    const { title = '', fileDate = '', documentNumber = '', details = [] } = filing || {};
    return (react_1.default.createElement(base_react_components_1.StandardCard, { "data-testid": testId },
        react_1.default.createElement(base_react_components_1.Copy, { bold: true }, title),
        react_1.default.createElement(CardContent, null,
            react_1.default.createElement(LabeledItemWrapper, null,
                react_1.default.createElement(labeled_value_1.LabeledValue, { label: "Date filed", underbar: "below" }, (0, utils_1.safeDateString)(fileDate)),
                react_1.default.createElement(labeled_value_1.LabeledValue, { label: "Filing number", underbar: "below" }, documentNumber)),
            react_1.default.createElement(zebra_list_1.default, null, details.map(({ value, label }, i) => (react_1.default.createElement(zebra_list_1.ZebraItem, { label: label, key: i }, value)))))));
};
exports.FilingCard = FilingCard;
exports.default = (0, styled_components_1.default)(exports.FilingCard).withConfig({ componentId: "reports-dibzvz" }) ``;
//# sourceMappingURL=index.js.map